<template>
  <div class="kb" ref="root">
    <!-- Триггер -->
    <button
      type="button"
      class="kb__btn"
      :aria-expanded="open ? 'true' : 'false'"
      aria-haspopup="menu"
      :disabled="disabled"
      @click="toggle"
    >
      <img
        class="kb__dots"
        :src="require('@/assets/img/hm/dots-menu.svg')"
        alt="Open menu"
      />
    </button>

    <!-- Поповер -->
    <div
      v-if="open"
      class="kb__popover"
      :class="{'kb__popover--to-left': toLeft}"
      role="menu"
      :style="{ zIndex: zIndex }"
      @click.stop
    >
      <ul class="kb__list">
        <li
          v-for="(item, i) in renderedItems"
          :key="item.key || i"
          class="kb__item"
        >
          <button
            type="button"
            class="kb__action"
            :class="{ 'is-disabled': isItemDisabled(item) }"
            :disabled="isItemDisabled(item)"
            role="menuitem"
            @click="activate(i)"
          >
            <span class="kb__icon">
              <img
                v-if="item.icon"
                :src="iconSrc(item.icon)"
                :alt="item.label"
              />
            </span>
            <span class="kb__label">
              {{ item.label }}
            </span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KebabMenu',
  props: {
    items: {
      type: Array,
      required: true,
    },
    context: {
      type: null,
      default: null,
    },
    disabled: { type: Boolean, default: false },
    closeOnItemClick: { type: Boolean, default: true },
    zIndex: { type: Number, default: 1000 },
    toLeft: { type: Boolean, default: false },
  },
  data() {
    return { open: false }
  },
  computed: {
    renderedItems() {
      return (
        this.items || []
      ).filter(it => this.isItemVisible(it))
    },
  },
  watch: {
    renderedItems(list) {
      if (!list.length) this.close()
    }
  },
  methods: {
    iconSrc(name) {
      if (!name) return ''
      if (/^(https?:)?\/\//.test(name) || name.startsWith('/') || name.startsWith('data:')) {
        return name
      }
      return require(`@/assets/img/hm/${ name }`)
    },
    isItemVisible(menuItem) {
      const v = Object.prototype.hasOwnProperty.call(menuItem, 'visible') ? menuItem.visible : true
      return typeof v === 'function' ? !!v(menuItem, this.context) : !!v
    },
    isItemDisabled(menuItem) {
      const d = menuItem && menuItem.disabled
      return typeof d === 'function' ? !!d(menuItem, this.context) : !!d
    },
    toggle() {
      if (this.disabled) return
      this.open ? this.close() : this.openPopover()
    },
    openPopover() {
      if (this.open) return
      if (!this.renderedItems.length) return
      this.open = true
      this.$nextTick(() => {
        document.addEventListener('click', this.onDocClick, true)
      })
    },
    close() {
      if (!this.open) return
      this.open = false
      document.removeEventListener('click', this.onDocClick, true)
    },
    onDocClick(e) {
      const root = this.$refs.root
      if (root && !root.contains(e.target)) this.close()
    },
    activate(i) {
      const menuItem = this.renderedItems[i]
      if (!menuItem || this.isItemDisabled(menuItem)) return
      if (typeof menuItem.onClick === 'function') {
        menuItem.onClick(this.context)
      }
      if (this.closeOnItemClick) this.close()
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick, true)
  },
}
</script>

<style scoped>
.kb {
  position: relative;
  display: inline-block;
}

.kb__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.3s;
}

.kb__btn:hover {
  background-color: rgba(0, 0, 0, .06);
}

.kb__btn:disabled {
  opacity: .5;
  cursor: default;
}

.kb__dots {
  width: 18px;
}

.kb__popover {
  position: absolute;
  top: 100%;
  left: 0;
  width: 200px;
  padding: 12px 10px;
  border: 1px solid #E9E9E9;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
}

.kb__popover--to-left {
  left: unset;
  right: 0;
}

.kb__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.kb__item {
  margin-bottom: 8px;
}

.kb__item:last-child {
  margin-bottom: 0;
}

.kb__item + .kb__item {
  margin-top: 4px;
}

.kb__action {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 4px 8px;
  border: 0;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.kb__action.is-disabled {
  opacity: .5;
  cursor: default;
}

.kb__action:hover {
  border-radius: 6px;
  background-color: #eee;
}

.kb__label {
  color: #091411;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
</style>
